import React, { useState } from 'react';
import CircularProgress from "@mui/material/CircularProgress";
import adminPortalCss from "../../myfin_v2/css/adminportal.module.css";
import DefaultCompany from "../../myfin_v2/assets/imgs/defaultCompany.png";
import { ReactComponent as SearchIcon } from "../../myfin_v2/assets/icons/search.svg";
import { ReactComponent as CloseGreyIcon } from "../../myfin_v2/assets/icons/close_grey.svg";

const SelectResponsibility = ({
    unrestrictedAcessData = [],
    userPermissionData = [],
    onCheckBoxChange,
    onGrantAllCompanyAccess,
    loading = false,
}) => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [showSearch, setShowSearch] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [isCompanyLoading, setIsCompanyLoading] = useState(false);

    const handleSelectCompany = (idx) => {
        if (selectedIndex === idx) return;
        setIsCompanyLoading(true);
        setSelectedIndex(idx);
        setTimeout(() => {
            setIsCompanyLoading(false);
        }, 200);
    };

    const selectedCompany =
        userPermissionData && userPermissionData[selectedIndex]
            ? { ...userPermissionData[selectedIndex], index: selectedIndex }
            : null;

    const indexedCompanies = (userPermissionData || []).map((item, idx) => ({
        ...item,
        originalIdx: idx,
    }));

    const filteredCompanies = searchTerm.trim()
        ? indexedCompanies.filter((item) =>
              item?.company?.company_name
                  ?.toLowerCase()
                  .includes(searchTerm.toLowerCase().trim())
          )
        : indexedCompanies;

    const isCompanyAllAccessGranted = Boolean(
        selectedCompany &&
        selectedCompany.components &&
        selectedCompany.components.length > 0 &&
        selectedCompany.components.every(
            (comp) =>
                comp.permission?.create &&
                comp.permission?.delete &&
                comp.permission?.share &&
                comp.permission?.all_access_granted
        )
    );

    return (
        <div className={adminPortalCss.companyResponsibilitiesContainer}>
            {/* Top Unrestricted Access / Creation of Company Section */}
            {unrestrictedAcessData && unrestrictedAcessData.length > 0 && (
                <div className={adminPortalCss.unrestrictedAccessCard}>
                    {unrestrictedAcessData.map((data, idx) => {
                        const isAllGranted =
                            data.permission?.all_access_granted ||
                            (data.permission?.create &&
                                data.permission?.delete &&
                                data.permission?.share);

                        return (
                            <div key={idx} className={adminPortalCss.unrestrictedCardInner}>
                                <div className={adminPortalCss.unrestrictedAccessHeader}>
                                    <span className={adminPortalCss.unrestrictedAccessText}>
                                        {data.title}
                                    </span>
                                    {isAllGranted && (
                                        <span className={adminPortalCss.allAccessGrantedBadge}>
                                            All access granted
                                        </span>
                                    )}
                                </div>
                                <div className={adminPortalCss.permissionActions}>
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="create"
                                            checked={Boolean(data.permission?.create)}
                                            onChange={(e) =>
                                                onCheckBoxChange(e.target, "unrestrictedAcess", idx)
                                            }
                                            className={adminPortalCss.customCheckbox}
                                        />
                                        Create
                                    </label>
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="delete"
                                            checked={Boolean(data.permission?.delete)}
                                            onChange={(e) =>
                                                onCheckBoxChange(e.target, "unrestrictedAcess", idx)
                                            }
                                            className={adminPortalCss.customCheckbox}
                                        />
                                        Delete
                                    </label>
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="share"
                                            checked={Boolean(data.permission?.share)}
                                            onChange={(e) =>
                                                onCheckBoxChange(e.target, "unrestrictedAcess", idx)
                                            }
                                            className={adminPortalCss.customCheckbox}
                                        />
                                        Share
                                    </label>
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="all_access_granted"
                                            checked={Boolean(data.permission?.all_access_granted)}
                                            onChange={(e) =>
                                                onCheckBoxChange(e.target, "unrestrictedAcess", idx)
                                            }
                                            className={adminPortalCss.customCheckbox}
                                        />
                                        All Access
                                    </label>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}

            {/* Main 2-Column Section */}
            <div className={adminPortalCss.companyPermissionContainer}>
                {/* Left Separate Container: Select Company List with Search */}
                <div className={adminPortalCss.companyListContainer}>
                    <div className={`${adminPortalCss.columnHeaderRow} ${adminPortalCss.selectCompanyHeader}`}>
                        {!showSearch ? (
                            <>
                                <span className={adminPortalCss.columnHeaderTitle}>
                                    Select Company
                                </span>
                                <SearchIcon
                                    className={adminPortalCss.searchTriggerIcon}
                                    onClick={() => setShowSearch(true)}
                                />
                            </>
                        ) : (
                            <div className={adminPortalCss.companySearchBox}>
                                <SearchIcon className={adminPortalCss.searchInsideSmall} />
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    placeholder="Search company..."
                                    autoFocus
                                    className={adminPortalCss.companySearchInput}
                                />
                                <CloseGreyIcon
                                    style={{ cursor: "pointer", width: 14, height: 14 }}
                                    onClick={() => {
                                        setShowSearch(false);
                                        setSearchTerm("");
                                    }}
                                />
                            </div>
                        )}
                    </div>

                    <div className={adminPortalCss.companyCardScrollList}>
                        {filteredCompanies && filteredCompanies.length > 0 ? (
                            filteredCompanies.map((item) => (
                                <div
                                    key={item.originalIdx}
                                    className={adminPortalCss.companyCard}
                                    onClick={() => handleSelectCompany(item.originalIdx)}
                                    style={{
                                        borderColor:
                                            selectedIndex === item.originalIdx
                                                ? "#3AB67D"
                                                : "#EAEEED",
                                        background:
                                            selectedIndex === item.originalIdx
                                                ? "#F4FAF5"
                                                : "#F8F9F9",
                                    }}
                                >
                                    <img
                                        className={adminPortalCss.companyImage}
                                        src={item.company?.logo_url || DefaultCompany}
                                        alt="company_img"
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = DefaultCompany;
                                        }}
                                    />
                                    <span className={adminPortalCss.companyName} style={{ fontSize: "15px" }}>
                                        {item.company?.company_name}
                                    </span>
                                </div>
                            ))
                        ) : (
                            <span className={adminPortalCss.noCompaniesFoundText}>
                                No companies found
                            </span>
                        )}
                    </div>
                </div>

                {/* Right Separate Container: Component Permissions for selected company */}
                <div className={adminPortalCss.permissionSectionContainer}>
                    <div className={adminPortalCss.columnHeaderRow}>
                        <span className={adminPortalCss.columnHeaderTitle}>
                            {selectedCompany?.company?.company_name || "Company Permissions"}
                        </span>
                        {selectedCompany && (
                            <label className={adminPortalCss.grantAllCheckboxLabel}>
                                <input
                                    type="checkbox"
                                    checked={isCompanyAllAccessGranted}
                                    onChange={() =>
                                        onGrantAllCompanyAccess &&
                                        onGrantAllCompanyAccess(selectedCompany.index)
                                    }
                                    className={adminPortalCss.customCheckbox}
                                />
                                <span style ={{ marginLeft: "-5px" }}>Grant Access to All</span>
                            </label>
                        )}
                    </div>

                    <div className={adminPortalCss.permissionCardContainer}>
                        {(loading || isCompanyLoading) ? (
                            <div className={adminPortalCss.loaderContainer}>
                                <CircularProgress size={36} sx={{ color: "#3AB67D" }} />
                            </div>
                        ) : selectedCompany && selectedCompany.components ? (
                            selectedCompany.components.map((component, idx) => {
                                const isAllCompGranted =
                                    component.permission?.all_access_granted ||
                                    (component.permission?.create &&
                                        component.permission?.delete &&
                                        component.permission?.share);

                                return (
                                    <div key={idx} className={adminPortalCss.permissionCard}>
                                        <div className={adminPortalCss.permissionCardHeader}>
                                            <span className={adminPortalCss.permissionTitle}>
                                                {component.title}
                                            </span>
                                            {isAllCompGranted && (
                                                <span className={adminPortalCss.allAccessGrantedBadge}>
                                                    All access granted
                                                </span>
                                            )}
                                        </div>
                                        <div className={adminPortalCss.permissionActions}>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="create"
                                                    checked={Boolean(component.permission?.create)}
                                                    onChange={(e) =>
                                                        onCheckBoxChange(
                                                            e.target,
                                                            selectedCompany.index,
                                                            idx
                                                        )
                                                    }
                                                    className={adminPortalCss.customCheckbox}
                                                />
                                                Create
                                            </label>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="delete"
                                                    checked={Boolean(component.permission?.delete)}
                                                    onChange={(e) =>
                                                        onCheckBoxChange(
                                                            e.target,
                                                            selectedCompany.index,
                                                            idx
                                                        )
                                                    }
                                                    className={adminPortalCss.customCheckbox}
                                                />
                                                Delete
                                            </label>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="share"
                                                    checked={Boolean(component.permission?.share)}
                                                    onChange={(e) =>
                                                        onCheckBoxChange(
                                                            e.target,
                                                            selectedCompany.index,
                                                            idx
                                                        )
                                                    }
                                                    className={adminPortalCss.customCheckbox}
                                                />
                                                Share
                                            </label>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="all_access_granted"
                                                    checked={Boolean(
                                                        component.permission?.all_access_granted
                                                    )}
                                                    onChange={(e) =>
                                                        onCheckBoxChange(
                                                            e.target,
                                                            selectedCompany.index,
                                                            idx
                                                        )
                                                    }
                                                    className={adminPortalCss.customCheckbox}
                                                />
                                                All Access
                                            </label>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <p style={{ color: "#4D6D64", fontSize: 13 }}>
                                Select a company to view permissions
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SelectResponsibility;

// const SelectResponsibility = ({
//     company,
//     onChange
// }) => {
//     return (
//         <>
//             <Accordion>
//                 <AccordionSummary
//                     className="text-uppercase font-inter"
//                     expandIcon={
//                         <ExpandMoreIcon
//                             style={{
//                                 width: "25px",
//                                 height: "25px",
//                                 borderRadius: "48px",
//                                 backgroundColor: "#F8F8F8",
//                                 color: "#717171",
//                             }}
//                         />
//                     }
//                     aria-controls="panel1-content"
//                     id="panel1-header"
//                 >
//                     {Array.isArray(company) ? "Access Granted" : company.company.company_name}
//                 </AccordionSummary>
//                 <AccordionDetails>
//                     <div className="container w-75">
//                         <p className="mt-0 mb-0  font-size-12 custom-font-600 font-sans">
//                             Access to:
//                         </p>
//                         <Card
//                             className="mt-2"
//                             style={{
//                                 border: "1px solid #D6D6D6",
//                                 borderRadius: "10px",
//                             }}
//                         >
//                             <table>
//                                 <thead className='custom-bg-white-150'>
//                                     <tr>
//                                         <th
//                                             style={{
//                                                 borderTopLeftRadius: "10px",
//                                             }}
//                                             className="text-uppercase font-inter font-size-12 custom-font-600 text-left"
//                                         >
//                                             Data
//                                         </th>
//                                         <th className="text-uppercase font-inter font-size-12 custom-font-600">
//                                             Create
//                                         </th>
//                                         <th className="text-uppercase font-inter font-size-12 custom-font-600">
//                                             Delete
//                                         </th>
//                                         <th className="text-uppercase font-inter font-size-12 custom-font-600">
//                                             Share
//                                         </th>
//                                         <th
//                                             style={{ borderTopRightRadius: "10px" }}
//                                             className="text-uppercase font-inter font-size-12 custom-font-600"
//                                         >
//                                             All Access
//                                         </th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {
//                                         Array.isArray(company) ? 
//                                             company.length > 0 && company.map((component, index) => (
//                                                 <TableRowPermission 
//                                                     component={component}
//                                                     index={index}
//                                                     onChange={onChange}
//                                                 />
//                                             ))
//                                         : company.components.length > 0 && company.components.map((component, index) => (
//                                             <TableRowPermission 
//                                                 component={component}
//                                                 index={index}
//                                                 onChange={onChange}
//                                             />
//                                         ))
//                                     }
//                                 </tbody>
//                             </table>
//                         </Card>
//                     </div>
//                 </AccordionDetails>
//             </Accordion>
//         </>
//     )
// }

// export default SelectResponsibility

// const CheckBoxPermission = ({
//     index,
//     checked,
//     name,
//     onChange
// }) => {
//     return <input
//         type="checkbox"
//         style={{ width: "20px", height: "20px" }}
//         name={name}
//         checked={checked}
//         onChange={(event) => onChange(event.target, index)}
//     />
// }

// const TableRowPermission = ({
//     index,
//     component,
//     onChange
// }) => {
//     return <tr key={index}>
//         <td
//             className="text-left border-top-0 border-bottom-0 mt-0 mb-0 pl-2 font-size-16 custom-font-500 font-sans"
//         >
//             {component.title}
//         </td>
//         <td className="border-top-0 border-bottom-0">
//             <CheckBoxPermission
//                 index={index}
//                 checked={component.permission.create}
//                 name="create"
//                 onChange={onChange}
//             />
//         </td>
//         <td className="border-top-0 border-bottom-0">
//             <CheckBoxPermission
//                 index={index}
//                 checked={component.permission.delete}
//                 name="delete"
//                 onChange={onChange}
//             />
//         </td>
//         <td className="border-top-0 border-bottom-0">
//             <CheckBoxPermission
//                 index={index}
//                 checked={component.permission.share}
//                 name="share"
//                 onChange={onChange}
//             />
//         </td>
//         <td className={`border-top-0 border-bottom-0`}>
//             <CheckBoxPermission
//                 index={index}
//                 checked={component.permission.all_access_granted}
//                 name="all_access_granted"
//                 onChange={onChange}
//             />
//         </td>
//     </tr>
// }